import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PublicPageAuthenticationTypes } from '@shared/constants/constants';
import { Store } from '@ngrx/store';
import { IState } from '@state/state.module';
import { UserProvisioningType } from '@shared/enums/UserProvisioningType';
import { IGetUserProvisioning } from '@shared/services/api/dashboard/user-provisionings-service/user-provsionings-model';

@Pipe({
    name: 'authenticationType'
})
export class AuthenticationTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number, provisioning: IGetUserProvisioning): string {
        let result = '';
        const itemsAuthenticationType = PublicPageAuthenticationTypes(this.translation, provisioning);
        if (itemsAuthenticationType){
            const selected = itemsAuthenticationType.find(x => x.id === value);
            if (selected) {
                result = selected.text;
            }
        }

        return result;
    }
}
